import { DateFormat, Locales as TwLocales } from 'react-ts-tradingview-widgets';

import type { Locale } from '@/i18n/i18n-config';

export const ourLocaleToTwLocale = (ourLocale: string): TwLocales => {
  // https://tradingview-widgets.jorrinkievit.xyz/docs/types/Locales
  // https://www.tradingview.com/charting-library-docs/latest/core_concepts/Localization
  const mapping: Record<string, TwLocales> = {
    en: 'en',
    pt: 'en',
    hi: 'en',
    bn: 'en',
    //
    es: 'es',
    in: 'in',
    tr: 'tr',
    vi: 'vi_VN',
    cn: 'zh_CN',
    jp: 'ja',
    kr: 'kr',
    ru: 'en',
    th: 'th_TH',
    ar: 'ar_AE',
  } as const;

  return mapping[ourLocale];
};

export function formatAssetNameToTradingViewWidgetPropsFormat(_assetName: string) {
  const assetName = _assetName;
  const map: Record<string, string> = {
    DOWJ: 'DJI',
    'HK-HSI': 'HK50',
    JAPAN: 'NIKKEI',
    FRANCE: 'CAC',
    SPAIN: 'IBEX35',
  };
  return (map[assetName] || assetName).replace(/[^A-z0-9]/, '');
}

export function getDateFormatFromLocale(locale: string): DateFormat {
  const formats: Record<Locale, DateFormat> = {
    hi: 'dd-MM-yyyy',
    jp: 'yyyy/MM/dd',
    kr: 'yyyy-MM-dd',
    cn: 'yyyy-MM-dd',
    bn: 'dd/MM/yyyy',
    es: 'dd/MM/yyyy',
    pt: 'dd/MM/yyyy',
    en: 'dd/MM/yyyy',
    ar: 'dd/MM/yyyy',
    ru: 'dd/MM/yyyy',
    in: 'dd/MM/yyyy',
    th: 'dd/MM/yyyy',
    tr: 'dd/MM/yyyy',
    vi: 'dd/MM/yyyy',
  };

  return formats[locale as Locale] || formats['en'];
}
